function attachBuyItNowInterceptor(button) {
  button.addEventListener('click', async (e) => {
    e.preventDefault(); // bloque la redirection

    const form = button.closest('form');
    if (!form) return;

    const formData = new FormData(form);
    const id = formData.get('id');
    const quantity = formData.get('quantity') || 1;

    if (!id) return console.error('Variant ID manquant !');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id), quantity: parseInt(quantity) })
      });
      const data = await res.json();
      console.log('Produit ajouté au cart :', data);

      // Ouvrir le cart drawer
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification && cartNotification.renderContents) {
        cartNotification.renderContents(data);
      }
    } catch (err) {
      console.error('Erreur ajout cart:', err);
    }
  });
}

// Observer le DOM pour détecter les boutons Shopify Payments
const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (!(node instanceof HTMLElement)) return;

      const buttons = node.matches('.shopify-payment-button__button')
        ? [node]
        : node.querySelectorAll('.shopify-payment-button__button');

      buttons.forEach(btn => attachBuyItNowInterceptor(btn));
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });
